import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const Houses = () => {
  useEffect(() => {
    document.title = "Houses -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Houses</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Houses</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ArjanHouse.pdf"
                    target="_blank"
                  >
                    {" "}
                    Arjan House{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/KatreHouse.pdf"
                    target="_blank"
                  >
                    {" "}
                    Katre House{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/LatifHouse.pdf"
                    target="_blank"
                  >
                    {" "}
                    Latif House{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/PratapHouse.pdf"
                    target="_blank"
                  >
                    {" "}
                    Pratap House{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SubrotoHouse.pdf"
                    target="_blank"
                  >
                    {" "}
                    Subroto House{" "}
                  </Link>{" "}
                </li>
              </ul>
                <h6>Inter House Activites : 2026-27</h6>
                     <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bouquet_making_competition_2026_27.pdf"
                    target="_blank"
                  >
                    {" "}
                  Bouquet Making Competition
                  </Link>{" "}
                </li>
               
               
              </ul>
              <h6>Inter House Activites : 2025-26</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/debate.pdf"
                    target="_blank"
                  >
                    {" "}
                    Debate Competition (English and Hindi){" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Board-Decoration.pdf"
                    target="_blank"
                  >
                    {" "}
                    Display Board Decoration Competition{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/3dPoster.pdf"
                    target="_blank"
                  >
                    {" "}
                    3d Poster Making Competition{" "}
                  </Link>{" "}
                </li>
              </ul>

              <h6>Inter House Activites : 2024-25</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/FusionDance.pdf"
                    target="_blank"
                  >
                    {" "}
                    Fusion Dance{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/DisplayBoard.pdf"
                    target="_blank"
                  >
                    {" "}
                    Display Board Decoration Competition{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/InvitationCard.pdf"
                    target="_blank"
                  >
                    {" "}
                    Invitation Card Making Competition{" "}
                  </Link>{" "}
                </li>
              </ul>
              <h6>Inter House Activites : 2023-24</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/RapSong.pdf"
                    target="_blank"
                  >
                    {" "}
                    Rap Song{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Ad Mad Show.pdf"
                    target="_blank"
                  >
                    {" "}
                    Ad Mad Show{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/GateDecoration.pdf"
                    target="_blank"
                  >
                    {" "}
                    Gate Decoration{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/StreetPlay.pdf"
                    target="_blank"
                  >
                    {" "}
                    Street Play{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/RangoliCompetition.pdf"
                    target="_blank"
                  >
                    {" "}
                    Paper Rangoli Competition - Festival Of India{" "}
                  </Link>{" "}
                </li>
              </ul>

              <h6>Inter House Activites : 2022-23</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/PicturesqueFilmMaking.pdf"
                    target="_blank"
                  >
                    {" "}
                    Picturesque Film Making{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/DiyAndPitch.pdf"
                    target="_blank"
                  >
                    {" "}
                    Diy And Pitch{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/StateFestival.pdf"
                    target="_blank"
                  >
                    {" "}
                    State Festival{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/RangoliCompetition22.pdf"
                    target="_blank"
                  >
                    {" "}
                    Rangoli Competition{" "}
                  </Link>{" "}
                </li>
              </ul>
              <h6>Inter House Activites : 2021-22</h6>
              <p>
                The Elemental Quistions :a Docuseries (Classes Ix-x) - 02 Jul
                2021{" "}
              </p>
              <ul className="list">
                <li>
                  {" "}
                  <Link
                    to="https://drive.google.com/file/d/1dXJgUk6Nyxu7XfP2Cisc3NmuV_oJQFFH/view"
                    target="_blank"
                  >
                    {" "}
                    Don't Be A Clown! Keep The Noise Down!{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://drive.google.com/file/d/1OaZL8P_8T7Jbrul1wTeIAOdpsKy-LFMQ/view"
                    target="_blank"
                  >
                    {" "}
                    Men Argue Nature Acts{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://drive.google.com/file/d/1ZKFT340qpKYMBcps67XWTOczk7DLD5vc/view"
                    target="_blank"
                  >
                    {" "}
                    Yoga - An Ancient But Perfect Science Of Life{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://drive.google.com/file/d/176bBn1ah9hycAPqFJh3Mtz776chhhEdP/view"
                    target="_blank"
                  >
                    {" "}
                    Ayurveda-the Science Of Life{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://drive.google.com/file/d/17cmwucFcMoEL51j2YEoS7zaLORuOxv_Y/view"
                    target="_blank"
                  >
                    {" "}
                    Cleanliness-the First Law Of Health{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/InterhouseActivity2jul21.PNG"
                    target="_blank"
                  >
                    {" "}
                    Inter-house Activity - Results{" "}
                  </Link>{" "}
                </li>
              </ul>
              <p>
                Solo Instrumental Music Competition (Fuukn) (Classes- Vii- Ix) -
                30 Jul 2021{" "}
              </p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/InterHouseActivity30jul21.PNG"
                    target="_blank"
                  >
                    {" "}
                    Inter House Activity - Results{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://drive.google.com/file/d/1DCwmJogVZ5B7SEKmi7zzlqImtNMJ1K0z/view?usp=sharing"
                    target="_blank"
                  >
                    {" "}
                    Video{" "}
                  </Link>
                </li>
              </ul>
              <p>Dance Competition - 11 Oct 2021 </p>
              <ul className="list mainlist">
                {" "}
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/InterHouseActivity.pdf"
                    target="_blank"
                  >
                    {" "}
                    Inter House Activity - Results{" "}
                  </Link>
                </li>
              </ul>
              <h6>
                <Link
                  to="https://drive.google.com/file/d/1oR-U2Gbg-ntUZ_iEl1Fmb74hqsrn3CW7/view"
                  target="_blank"
                >
                  {" "}
                  IHA- Final Results 2021-22{" "}
                </Link>{" "}
              </h6>

              <h6>Inter House Activites : 2020-21</h6>
              <ul className="list">
                <li>
                  {" "}
                  <Link
                    to="https://www.youtube.com/watch?v=GUAwm7qGRvY"
                    target="_blank"
                  >
                    {" "}
                    Online Presentation - Class Viii{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://www.youtube.com/watch?v=LTZuSd3NZUo"
                    target="_blank"
                  >
                    {" "}
                    Power Point Presentation - Class Xi Result - 31 July
                    2020{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://cloud9.shauryasoft.com/media/contentpage_105_45_20.pdf?Nv84r"
                    target="_blank"
                  >
                    {" "}
                    Inter House News Debate - Class Ix{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/HouseScoresResults20.pdf"
                    target="_blank"
                  >
                    {" "}
                    Inter House Fitness Week 2020 : House Scores Results{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SoloDanceCompetition.pdf"
                    target="_blank"
                  >
                    {" "}
                    Inter House Solo Dance Competition : Classes Vi-ix{" "}
                  </Link>{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Houses;
